import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root'
})
export class GraphService {
  constructor(private http: HttpClient) { }
  public resolveName(id: string) : Observable<any> | undefined {

     var isId : boolean = false;

      if(id.includes("28:orgid:"))
      {
        id = id.replace("28:orgid:","");

        isId = true;
        
      }
      else if(id.includes("8:orgid:"))
      {
        id = id.replace("8:orgid:","");

        isId = true;
      }
      if(isId)
      {
        return this.http.get("https://graph.microsoft.com/v1.0/users/" + id + "?$select=displayName");
      }
      else
      {
        return undefined;
      }


      
  }

  public search(text: string)
  {
    
  }
}
